//引入
//import BuriedPointPlugin from '../../static/js/track-h5-1.0.0.js';
//使用
// Vue.use(BuriedPointPlugin, {
// 	$lib_version: '1.0.0', // 埋点SDK版本
// 	project_id: 'TP24050717590215', // PC对应的埋点的ID
// 	client_code: 'CLI3539340242345525248', // 客户编号
// 	settingPara:{
// 	  server_url: jm.site.CDP + '/api/v1/ncdp/track/event/reporting',
// 	  show_log: true, // 是否开启日志
// 	  token_name: "ACT24050611345478_token",// 获取storage中token的名称
// 	  gps_name: 'gps', // 获取storage中gps的名称
// 	  longitude_name: 'longitude', // 获取storage中gps的经度名称
// 	  latitude_name: 'dimension', // 获取storage中gps的纬度名称
// 	  gps_provice_name: 'province_name', // 获取storage中gps的省名称
// 	  gps_city_name: 'city_name', // 获取storage中gps的市名称
// 	  gps_area_name: 'area_name', // 获取storage中gps的区名称
// 	  gps_address_name: 'address', // 获取storage中gps的地址名称
// 	}
// });

//点击事件埋点
//v-track-click="{eventid: 'TRC24050718002060',element_id: '11111',element_type: '2222',element_name: '3333',element_content: '4444',reporting: true}"

//公共字段
//在SDK初始化时配置如下：（可配置也可不配置）
//BuriedPointPlugin.setCommonFields({
// 	"$common_field_" + 后台配置的ID: 内容,
// 	示例: "$common_field_xxxxxxx": "值"
//})
//页面上如果优先于项目配置，则在页面data内添加$common_field对象，对象下添加key即可
//$common_field: {
// 	"$common_field_" + 后台配置的ID: 内容,
//}
//示例: $common_fields: {
// 	"$common_field_xxxxxxx": "值"
//}


// 埋点插件
var saPara = {
	name: 'geement', // 写死geement，在非app.js中可以通过getApp().sensors(你这里定义的名字来使用)
	project_id: '', // PC对应的埋点的ID（可配置）
	client_code: '', // 客户编号（可配置）
	$lib: 'H5', // 埋点SDK 类型 （默认MiniProgram：小程序）
	$lib_version: '1.0.0', // 埋点SDK 版本
	$screen_height: '', // 小程序屏幕高度
	$screen_width: '', // 小程序屏幕宽度
	$device_model: '', // 设备型号
	$device_brand: '', // 设备品牌
	$device_os: '', // 操作系统
	$device_os_version: '', // 操作系统版本
	$longitude: '', // 经度
	$latitude: '', // 纬度
	$gps_provice: '', // 省
	$gps_city: '', // 市
	$gps_area: '', // 区
	$gps_address: '', // 地址
	network_type: '', // 网络类型
	$on_page_title: '', // 页面标题
	$on_page_url: '', // 页面地址(包含参数)
	$on_page_url_path: '', // 页面路径(纯路径)
	$url_query: '', // 页面参数
	page_show_time: '', // 页面onShow时的时间戳
	$page_duration: '', // 页面浏览时间（采集的是onShow到onHide 或 onUnload 触发的时间，单位秒）
	settingPara: {
		server_url: '', // 数据接收地址（可配置）
		show_log: false, // 是否开启日志(可配置)
		token_name: "apitoken", // 获取storage中token的名称(可配置)
		gps_name: 'gps', // 获取storage中gps的名称(可配置)
		longitude_name: 'longitude', // 获取storage中gps的经度名称
		latitude_name: 'latitude', // 获取storage中gps的纬度名称
		gps_provice_name: 'province_name', // 获取storage中gps的省名称
		gps_city_name: 'city_name', // 获取storage中gps的市名称
		gps_area_name: 'area_name', // 获取storage中gps的区名称
		gps_address_name: 'address', // 获取storage中gps的地址名称
	}
}

var commonFileds = {}

var pageTaskList = []; // 需要上报的数据列表

var listName = 'geement_track_taskList'; // 需要上报的数据在storage中的名称
var tokenName = 'geement_track_token'; // 埋点的身份令牌在storage中的名称
var pathName = 'geement_track_path'; // 当前页面路径在storage中的名称

var pagePathData = {}; // 页面的路径、参数等（便于自定义埋点调用track时，上报数据）

var MP_NAME_LIST = ['$MPViewScreen', '$APPPageLeave', '$MPClick']

const BuriedPointPlugin = {
	install(Vue, options) {
		// console.log(options)
		saPara = Object.assign({}, saPara, options)

		if (!saPara.settingPara.server_url) {
			console.log('请使用 init() 方法设置 server_url 数据接收地址')
			return;
		}

		if (!saPara.project_id) {
			console.log('请使用 init() 方法设置 project_id 埋点的ID')
			return;
		}

		if (!saPara.client_code) {
			console.log('请使用 init() 方法设置 client_code 获取客户编号')
			return;
		}

		//获取设备信息
		getSystemInfo()

		// 初始化定时任务
		batchInterval();

		// 监听页面的访问时间
		Vue.mixin({
			//进入页面
			beforeRouteEnter(to, from, next) {
				pagePathData = Object.assign(pagePathData, {
					$on_page_title: to.name || to.meta.title || 'unknown',
					$on_page_url: to.fullPath,
					$on_page_url_path: to.path,
					$url_query: to.fullPath.split("?")[1] || "",
				})

				getConfig().then(() => {
					let data = {
						$on_page_title: to.name || to.meta.title || 'unknown',
						$on_page_url: to.fullPath,
						$on_page_url_path: to.path,
						page_show_time: (new Date).getTime()
					}
					saPara.page_show_time = data.page_show_time

					localStorage.setItem(pathName, to.path);

					track("$MPViewScreen", getTrackData(Object.assign({}, saPara, data)))

					next();
				})
			},
			//离开页面
			beforeRouteLeave(to, from, next) {
				getConfig().then(() => {
					const pageName = from.name || from.meta.title || 'unknown';
					const path = localStorage.getItem(pathName);

					let data = {
						$on_page_title: pageName,
						$on_page_url: from.fullPath,
						$on_page_url_path: from.path,
					}

					if (saPara.page_show_time >= 0 && path != '') {
						data.$page_duration = (Date.now() - saPara.page_show_time) / 1000
					}

					track("$APPPageLeave", getTrackData(Object.assign({}, saPara, data)))

					localStorage.setItem(pathName, from.path);

					next();
				})

			},
		});

		// 自定义点击监听
		Vue.directive('track-click', {
			bind(el, binding) {
				el.addEventListener('click', (e) => {
					const {
						value
					} = binding;
					// 这里可以根据需要记录点击事件的信息
					var obj = {}

					obj.$geement_event_id = value.eventid || ''
					obj.$element_id = value.element_id
					obj.$element_type = value.element_type
					obj.$element_name = value.element_name
					obj.$element_content = value.element_content

					//点击事件上自定义参数对象
					for (let key in value) {
						if (!['eventid', 'element_id', 'element_type', 'element_name',
								'element_content'
							].includes(key)) {
							obj[key] = value[key]
						}
					}

					getConfig().then(() => {
						const data = getTrackData(Object.assign({}, saPara, obj))

						if (obj.$geement_event_id) {
							if (value.reporting) {
								console.log('000000')

								batchSend([{
									event_id: obj.$geement_event_id,
									content: data,
									event_time: new Date().getTime()
								}])
							} else {
								track(obj.$geement_event_id, data)
							}
						} else {
							if (value.reporting) {
								console.log('11111')

								batchSend([{
									event_id: "$MPClick",
									content: data,
									event_time: new Date().getTime()
								}])
							} else {
								track("$MPClick", data)
							}
						}
					})
				});
			}
		});
	},
};

// 获取设备信息
function getSystemInfo() {
	const promise = new Promise(resolve => {
		let obj = {}
		obj = {
			$screen_width: window.innerWidth || document.documentElement.clientWidth || document.body
				.clientWidth,
			$screen_height: window.innerHeight || document.documentElement.clientHeight || document.body
				.clientHeight,
			$device_model: getDeviceModel(),
			$device_brand: getDeviceBrand(),
			$device_os: getOS(),
			$device_os_version: getOSVersion()
		}
		saPara = Object.assign(saPara, obj)
		resolve(obj)
	})
	return promise
}
//获取设备型号
function getDeviceModel() {
	// 获取用户代理字符串
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	// 使用正则表达式匹配常见的设备型号
	var matches;
	// Android
	if (matches = userAgent.match(/Android ([0-9.]*)/)) {
		return 'Android ' + matches[1];
	}
	// iOS
	if (matches = userAgent.match(/iPad; CPU OS ([0-9._]*)/)) {
		return 'iPad ' + matches[1].replace(/_/g, '.');
	} else if (matches = userAgent.match(/iPhone OS ([0-9._]*)/)) {
		return 'iPhone ' + matches[1].replace(/_/g, '.');
	} else if (matches = userAgent.match(/iPod touch; CPU OS ([0-9._]*)/)) {
		return 'iPod ' + matches[1].replace(/_/g, '.');
	}
	// Windows Phone
	if (matches = userAgent.match(/Windows Phone OS ([0-9.]*)/)) {
		return 'Windows Phone ' + matches[1];
	}
	// 无法识别的设备
	return 'Unknown';
}
//获取设备品牌
function getDeviceBrand() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	if (userAgent.indexOf("Android") > -1) {
		return "Android";
	}
	if (userAgent.indexOf("iPhone") > -1) {
		return "iPhone";
	}
	if (userAgent.indexOf("iPad") > -1) {
		return "iPad";
	}
	if (userAgent.indexOf("iPod") > -1) {
		return "iPod";
	}
	if (userAgent.indexOf("BlackBerry") > -1) {
		return "BlackBerry";
	}
	if (userAgent.indexOf("IEMobile") > -1) {
		return "Windows Phone";
	}
	return "unknown";
}
//获取设备操作系统
function getOS() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	if (userAgent.indexOf("Windows NT 10.0") != -1) return "Windows 10";
	if (userAgent.indexOf("Windows NT 6.2") != -1) return "Windows 8";
	if (userAgent.indexOf("Windows NT 6.1") != -1) return "Windows 7";
	if (userAgent.indexOf("Windows NT 6.0") != -1) return "Windows Vista";
	if (userAgent.indexOf("Windows NT 5.1") != -1) return "Windows XP";
	if (userAgent.indexOf("Windows NT 5.0") != -1) return "Windows 2000";
	if (userAgent.indexOf("Mac") != -1) return "Mac/iOS";
	if (userAgent.indexOf("X11") != -1) return "UNIX";
	if (userAgent.indexOf("Linux") != -1) return "Linux";
	return "Unknown";
}
//获取设备操作系统版本
function getOSVersion() {
	const userAgent = navigator.userAgent;
	let osVersion = 'Unknown';
	if (/Windows NT/.test(userAgent)) {
		// Windows 操作系统的用户代理字符串格式为 "Windows NT x.x"
		const match = /Windows NT (\d+\.\d+)/.exec(userAgent);
		if (match) {
			osVersion = match[1];
		}
	} else if (/Mac OS X/.test(userAgent)) {
		// macOS 操作系统的用户代理字符串格式为 "Mac OS X xx_x"
		const match = /Mac OS X (\d+_\d+)/.exec(userAgent);
		if (match) {
			osVersion = match[1].replace('_', '.');
		}
	} else if (/Android/.test(userAgent)) {
		// Android 操作系统的用户代理字符串格式为 "Android x.x"
		const match = /Android (\d+\.\d+)/.exec(userAgent);
		if (match) {
			osVersion = match[1];
		}
	} else if (/iOS|iPhone|iPad|iPod/.test(userAgent)) {
		// iOS 操作系统的用户代理字符串格式为 "iOS xx.xx"
		const match = /OS (\d+_\d+)/.exec(userAgent);
		if (match) {
			osVersion = match[1].replace('_', '.');
		}
	}
	return osVersion;
}

// 获取经纬度、网络类型等
function getConfig() {
	const promise = new Promise(resolve => {
		// 获取经纬度，省市区地址
		const gps = localStorage.getItem(saPara.settingPara.gps_name);

		if (gps) {
			saPara.$longitude = gps[saPara.settingPara.longitude_name]
			saPara.$latitude = gps[saPara.settingPara.latitude_name]
			saPara.$gps_provice = gps[saPara.settingPara.gps_provice_name]
			saPara.$gps_city = gps[saPara.settingPara.gps_city_name]
			saPara.$gps_area = gps[saPara.settingPara.gps_area_name]
			saPara.$gps_address = gps[saPara.settingPara.gps_address_name]
		}

		saPara.network_type = getNetworkType()
		resolve()
	})

	return promise
}
//获取网络类型
function getNetworkType() {
	const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
	if (connection && connection.type) {
		return connection.type;
	} else {
		return 'Unknown';
	}
}

// 打印日志
function log() {
	if (saPara.settingPara.show_log && "object" == typeof console && console.log)
		try {
			console.log.apply(console, arguments)
		} catch (e) {
			console.log(arguments[0])
		}
}

// 用于往队列里push需要上报的任务
function track(name, params) {
	if (JSON.stringify(commonFileds) !== "{}") {
		// const page = getCurrentPages();
		// commonFileds = Object.assign({}, commonFileds, page[0].data.$common_fields)
		params = Object.assign({}, params, commonFileds)
	}

	const data = {
		event_id: name,
		content: params,
		event_time: new Date().getTime()
	}

	if (!MP_NAME_LIST.includes(name)) {
		data.content = Object.assign({}, params, pagePathData)
	}

	pageTaskList = batchRead();
	pageTaskList.push(data);

	batchWrite(pageTaskList);
}
// 获取storage任务列表
function batchRead() {
	try {
		return localStorage.getItem(listName) ? JSON.parse(localStorage.getItem(listName)) : [];
	} catch (e) {
		log("get Storage fail --", e);
	}
}
// 存储storage任务列表
function batchWrite(data) {
	try {
		localStorage.setItem(listName, JSON.stringify(data));
	} catch (e) {
		log("set Storage fail --", e);
	}
}

// 定时任务（包含往storage里存任务列表，以及每3秒进行上报）
function batchInterval() {
	// 上报埋点数据
	const sendMessage = function() {
		setTimeout(function() {
			if (pageTaskList.length > 0) {
				batchSend();
			}
			sendMessage();
		}, 3000)
	}
	sendMessage();
}

// 上报埋点数据
function batchSend(data) {

	let token = localStorage.getItem(saPara.settingPara.token_name);
	token = token ? token : localStorage.getItem(tokenName);

	if (token) {
		sendApi(token, data)
	} else {
		// // 登录
		// login().then(() => {
		// 	sendApi()
		// })
	}
}

// 调用接口上报
function sendApi(token, params) {
	pageTaskList = batchRead();
	const data = params ? params : pageTaskList.slice(0, 10)

	const xhr = new XMLHttpRequest();
	// 设置请求方法和 URL
	xhr.open('POST', saPara.settingPara.server_url, true);
	// 设置请求头
	xhr.setRequestHeader('Content-Type', 'application/json');
	// 设置请求头
	xhr.setRequestHeader('apitoken', token);
	// 监听请求完成事件
	xhr.onload = function() {
		if (xhr.status >= 200 && xhr.status < 300) {
			// 请求成功
			let res = JSON.parse(xhr.response);
			if (res.code == 200 && res.success) {
				if (!params) {
					// 将已上报的删除
					pageTaskList.splice(0, data.length)
					batchWrite(pageTaskList);
				}
				log('上报成功！');
			} else {
				if (res.code == 311 || res.code == 310 || res.msg == '请登录') {
					// token失效，清除本地token
					localStorage.setItem(tokenName, "");
				}

				log('上报埋点失败！' + res.code + res.msg);
			}
		} else {
			// 请求失败
			log('上报埋点失败-----Request failed with status:' + xhr.status);
		}
	};
	// 监听网络错误事件
	xhr.onerror = function(error) {
		log('上报埋点失败-----网络错误' + error);
	};
	// 发送请求
	xhr.send(JSON.stringify({
		project_id: saPara.project_id,
		events: data
	}));
}

//设置公共字段
function setCommonFields(obj) {
	commonFileds = obj
}

//获取埋点参数
function getTrackData(obj) {
	var trackData = JSON.parse(JSON.stringify(obj))
	delete trackData.settingPara
	return trackData;
}


BuriedPointPlugin.setCommonFields = setCommonFields;

export default BuriedPointPlugin;


//////////////////
// WEBPACK FOOTER
// ./static/js/track-vue-1.0.0.js
// module id = null
// module chunks = 